export class Ng2selectObject {

    public id: string;
    public text: string;

    constructor(id: string, text: string) {
      this.id = id;
      this.text = text
    }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/dto/ng2selectObject.ts